import { Card } from "../models/Card";
import { Deck } from "../models/Deck";
import { ValidationMessage } from "../models/ValidationMessage";
import { DeckRule, EqualTotalDeckNumberOfSheets, EqualTotalNumberOfFavoriteCards, LessNumberOfDuplicateCards, LessNumberOfProducts } from "./DeckRules";

export default class DeckValidator {

    private static equalTotalDeckNumberOfSheets = new EqualTotalDeckNumberOfSheets();
    private static equalTotalNumberOfFavoriteCards = new EqualTotalNumberOfFavoriteCards();
    private static lessNumberOfDuplicateCards = new LessNumberOfDuplicateCards();
    private static lessNumberOfProducts = new LessNumberOfProducts();

    private static rules: DeckRule[] = [
        DeckValidator.equalTotalDeckNumberOfSheets,
        DeckValidator.equalTotalNumberOfFavoriteCards,
        DeckValidator.lessNumberOfDuplicateCards,
        DeckValidator.lessNumberOfProducts
    ];

    /**
     * 現在のデッキの検証結果を取得します。
     */
    public static validate(deck: Deck) {
        const errors: ValidationMessage[] = [];

        this.rules.forEach((rule) => {
            const result = rule.validate(deck);
            if (result) {
                errors.push.apply(result);
            }
        });

        return errors;
    }

    /**
     * カードを挿入した場合の検証結果を取得します。
     * @param deck 
     * @param card 
     */
    public static validateInseringCard(deck: Deck, card: Card) {
        const errors: ValidationMessage[] = [];

        //作品数が設定値以上に増えないことを確認する
        const productValidateResult = this.lessNumberOfProducts.preValidate(deck, card, false);
        if (productValidateResult) {
            Array.prototype.push.apply(errors, productValidateResult);
        }

        //重複カード数が設定値以上に増えないことを確認する
        const duplicateValidateResult = this.lessNumberOfDuplicateCards.preValidate(deck, card, false);
        if (duplicateValidateResult) {
            Array.prototype.push.apply(errors, duplicateValidateResult);
        }

        //カード数が設定値以上に増えないことを確認する
        const totalCountValidateResult = this.equalTotalDeckNumberOfSheets.preValidate(deck, card, false);
        if (totalCountValidateResult) {
            Array.prototype.push.apply(errors, totalCountValidateResult);
        }

        return errors;
    }

    /**
     * カードを推しに変更する場合の検証結果を取得します。
     * @param deck 
     * @param card 
     */
    public static validateMarkFavorite(deck: Deck, card: Card) {
        const errors: ValidationMessage[] = [];

        //推しカード数が設定値以上に増えないことを確認する
        const favoriteValidateResult = this.equalTotalNumberOfFavoriteCards.preValidate(deck, card, true);
        if (favoriteValidateResult) {
            Array.prototype.push.apply(errors, favoriteValidateResult);
        }

        return errors;
    }
}